import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from "@madmedical/form";
import BaseFormError from "../molecules/Form/FormError";
const FormError = () => {
    var _a, _b;
    const { formState: { errors }, } = useFormContext();
    const formError = (_b = (_a = errors.root) === null || _a === void 0 ? void 0 : _a.formError) === null || _b === void 0 ? void 0 : _b.message;
    if (!formError) {
        return null;
    }
    return _jsx(BaseFormError, { error: formError });
};
export default FormError;
